enum PAYMENT {
  credit = "Crédito",
  boleto = "Boleto",
  ticket = "Boleto",
  debit = "Débito",
  card = "Cartão",
  pix = "Pix",
  payout_automatic = "Crédito Automático"
}

export function translatePaymentType (status: string) {
  return PAYMENT[status as keyof typeof PAYMENT] ?? "Não informado";
}